'use client'
import Modal from '@/components/modal'
import React, { useState } from 'react'
import { FiArrowUpRight } from 'react-icons/fi'
import Link from 'next/link'

const Partner = () => {
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(!open)
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    console.log('shoemodaaa', showModal)
    setShowModal(true)
    console.log('shoemodaaa', showModal)
  }

  const closeModal = () => {
    setShowModal(false)
  }
  return (
    <>
      <div className="max-w-7xl mx-auto mainpartner px-5 mt-12 py-[60px]">
        <div className="flex justify-center">
          <p className="font-semibold text-[48px] leading-[60px] text-center text-white lg:w-[770px]">
            Curious About This Endeavour?
          </p>
        </div>
        <div className="flex justify-center mt-4">
          <p className="text-[20px] font-normal leading-[30px] text-white lg:w-[770px] text-center">
            Exploring new horizons? Dive into the depths of knowledge with us.
            Feel free to reach out – Your questions fuel our journey.
          </p>
        </div>
        <div className="flex-col flex md:flex-row justify-center gap-4 mt-10">
          <Link
            href="/about"
            className="bg-white bg-opacity-10  flex justify-center items-center px-5  rounded border border-transparent	 hover:border hover:border-[#155EEF] hover:shadow-lg hover:shadow-[#155EEF] md:w-[225px] h-[60px] text-center"
          >
            <button className="text-[#fff] text-[18px] font-semibold leading-[28px] w-full">
              <p className="-m-1.5 p-1.5">Contact Startup</p>
            </button>
            <FiArrowUpRight className="text-[#fff] text-[18px] font-semibold leading-[28px]" />
          </Link>
          <Link
            href="/i/profile"
            className="bg-[#141414] gap-3 flex justify-center items-center px-5 text-center rounded border border-[#155eef] hover:border hover:border-[#155EEF] hover:shadow-lg hover:shadow-[#155EEF] md:w-[281px] h-[60px]"
            // onClick={openModal}
          >
            <button className="text-[#fff] text-[18px] font-semibold leading-[28px] text-center">
              Become an Investor
            </button>
            <FiArrowUpRight className="text-[#fff] text-[18px] font-semibold leading-[28px]" />
          </Link>
        </div>
        {/* modal box code  */}
        {/* <Modal showModal={showModal} setShowModal={setShowModal} /> */}

        {/* end */}
      </div>
    </>
  )
}

export default Partner
